import {LabDataConfig} from './declarations/LabDataConfig'

export const DEFAULT_LAB_DATA_CONFIG: LabDataConfig = {
  id: '',
  millNames: [],
  siloNames: [],
  defaultMills: [],
  defaultSilos: []
}
